import React, { Component } from 'react';
import { Formik, Field, ErrorMessage } from 'formik';
import { Link, Redirect } from 'react-router-dom';
import Button from '../utility/Button';
import CustomInput from '../utility/CustomInput';
import CustomCheckbox from '../utility/CustomCheckbox';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Auth } from 'aws-amplify';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import { getAuthErr } from '../../js/utility';

import iconFB from '../../images/icons/icon_fb_white.png';
import iconGoogle from '../../images/icons/icon_google_white.png';
import iconEmail from '../../images/icons/icon_email.png';

import { doSignUp, clearAuthError } from '../../actions/auth';
import { setSignupFlow } from '../../actions/contest';

import { SITE_TITLE } from '../../constants';

import {
  validateEmail,
  validateEnglishOnly,
  validatePassword,
  validateMatchPassword,
  validateChecked,
  validateMobileNo
} from '../../js/validators';

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailSignup: false
    };
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
  }

  componentDidMount() {
    this.props.clearAuthError();
  }

  handleFieldBlur(e, blurHandler) {
    const { authError, clearAuthError } = this.props;
    if (authError) {
      clearAuthError();
    }
    blurHandler(e);
  }

  render() {
    const {
      doSignUp,
      authError,
      email,
      loading,
      t,
      contest,
      setSignupFlow
    } = this.props;
    const { emailSignup } = this.state;

    return (
      <div className='fe-auth-inner-container'>
        <Helmet>
          <title>
            {t('form:signUp')} | {SITE_TITLE}
          </title>
        </Helmet>
        {!emailSignup ? (
          <>
            {contest && (
              <h2 className='title big'>
                Before you can vote,
                <br /> be sure to sign up!
              </h2>
            )}
            <h1 className='fe-auth-heading'>{t('form:signUp')}</h1>
            <div className='fe-auth-text'>{t('form:signUpPreText')}</div>
            <div className='fe-auth-signup-buttons'>
              <div className='fe-auth-social-buttons'>
                <Button
                  className='btn-auth full facebook'
                  preIcon={iconFB}
                  onClick={() => Auth.federatedSignIn({ provider: 'Facebook' })}
                >
                  {t('form:continueWith', { social: 'Facebook' })}
                </Button>
                <Button
                  className='btn-auth full google'
                  preIcon={iconGoogle}
                  onClick={() => Auth.federatedSignIn({ provider: 'Google' })}
                >
                  {t('form:continueWith', { social: 'Google' })}
                </Button>
              </div>
              <div
                className='fe-auth-note'
                dangerouslySetInnerHTML={{
                  __html: t('form:socialSignInNote', {
                    tnc: `<a href="/getaways/terms-and-conditions">${t(
                      'form:tnc'
                    )}</a>`
                  })
                }}
              />
              <div className='fe-auth-divider'>
                <span>{t('form:or')}</span>
              </div>
              <Button
                className='btn-auth full email'
                preIcon={iconEmail}
                onClick={() => this.setState({ emailSignup: true })}
              >
                {t('form:signUpEmail')}
              </Button>
            </div>
          </>
        ) : (
          <>
            <h1 className='fe-auth-heading'>{t('form:signUp')}</h1>
            <div className='fe-auth-text'>{t('form:signUpPreText')}</div>
            <Formik
              validateOnChange={true}
              validateOnBlur={true}
              initialValues={{
                email: '',
                password: '',
                retypePassword: '',
                name: '',
                mobile: '',
                newsletter: false,
                agree: false
              }}
              onSubmit={values => {
                doSignUp(
                  values.email,
                  values.password,
                  values.name,
                  values.mobile,
                  values.newsletter,
                  values.agree
                );
              }}
            >
              {({ errors, values, handleBlur, handleSubmit }) => (
                <form noValidate onSubmit={handleSubmit} className='fe-form'>
                  <div className='fe-form-content'>
                    <div className='fe-form-field full'>
                      <label htmlFor='email'>{t('form:email')}</label>
                      <Field
                        onBlur={e => this.handleFieldBlur(e, handleBlur)}
                        type='text'
                        name='email'
                        component={CustomInput}
                        validate={validateEmail}
                      />
                    </div>
                    <div className='fe-form-field full'>
                      <label htmlFor='password'>{t('form:password')}</label>
                      <Field
                        onBlur={e => this.handleFieldBlur(e, handleBlur)}
                        type='password'
                        name='password'
                        isPassword
                        showError={false}
                        component={CustomInput}
                        validate={validatePassword}
                      />
                    </div>
                    <div className='fe-form-field full'>
                      <div>Complete these password requirements</div>
                      <ul>
                        <li
                          className={`${
                            (errors.password !== undefined &&
                              errors.password.indexOf('fPasswordUppercase') >
                                -1 ===
                                false) ||
                            (values.password !== '' &&
                              errors.password === undefined)
                              ? 'ok'
                              : ''
                          }`}
                        >
                          <div
                            className={`dot ${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPasswordUppercase') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          />
                          One uppercase character
                        </li>
                        <li
                          className={`${
                            (errors.password !== undefined &&
                              errors.password.indexOf('fPasswordLowercase') >
                                -1 ===
                                false) ||
                            (values.password !== '' &&
                              errors.password === undefined)
                              ? 'ok'
                              : ''
                          }`}
                        >
                          <div
                            className={`dot ${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPasswordLowercase') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          />
                          One lower character
                        </li>
                        <li
                          className={`${
                            (errors.password !== undefined &&
                              errors.password.indexOf('fPasswordNumber') >
                                -1 ===
                                false) ||
                            (values.password !== '' &&
                              errors.password === undefined)
                              ? 'ok'
                              : ''
                          }`}
                        >
                          <div
                            className={`dot ${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPasswordNumber') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          />
                          One number
                        </li>
                        <li
                          className={`${
                            (errors.password !== undefined &&
                              errors.password.indexOf('fPasswordSymbol') >
                                -1 ===
                                false) ||
                            (values.password !== '' &&
                              errors.password === undefined)
                              ? 'ok'
                              : ''
                          }`}
                        >
                          <div
                            className={`dot ${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPasswordSymbol') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          />
                          One symbol or special character
                        </li>
                        <li
                          className={`${
                            (errors.password !== undefined &&
                              errors.password.indexOf('fPasswordNoSpace') >
                                -1 ===
                                false) ||
                            (values.password !== '' &&
                              errors.password === undefined)
                              ? 'ok'
                              : ''
                          }`}
                        >
                          <div
                            className={`dot ${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPasswordNoSpace') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          />
                          Cannot contain spaces
                        </li>
                        <li
                          className={`${
                            (errors.password !== undefined &&
                              errors.password.indexOf('fPassword8Chars') >
                                -1 ===
                                false) ||
                            (values.password !== '' &&
                              errors.password === undefined)
                              ? 'ok'
                              : ''
                          }`}
                        >
                          <div
                            className={`dot ${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPassword8Chars') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          />
                          8 characterts minimum
                        </li>
                      </ul>
                    </div>
                    <div className='fe-form-field full'>
                      <label htmlFor='password'>
                        {t('form:confirmPassword')}
                      </label>
                      <Field
                        type='password'
                        name='retypePassword'
                        isPassword
                        component={CustomInput}
                        validate={val =>
                          validateMatchPassword(val, values.password)
                        }
                      />
                    </div>
                    <div className='fe-form-field full'>
                      <label htmlFor='name'>{t('form:fullNameAsIC')}</label>
                      <Field
                        onBlur={e => this.handleFieldBlur(e, handleBlur)}
                        type='text'
                        name='name'
                        component={CustomInput}
                        validate={validateEnglishOnly}
                      />
                    </div>
                    <div className='fe-form-field full'>
                      <label htmlFor='mobile'>{t('form:mobileNo')}</label>
                      <div className='fe-form-field-mobile'>
                        <div className='fe-form-mob-prefix'>+60</div>
                        <Field
                          onBlur={e => this.handleFieldBlur(e, handleBlur)}
                          type='text'
                          name='mobile'
                          component={CustomInput}
                          validate={validateMobileNo}
                          numbersOnly
                          showError={false}
                        />
                      </div>
                      <span className='fe-form-error'>
                        <ErrorMessage
                          name='mobile'
                          render={msg => t(`error:${msg}`)}
                        />
                      </span>
                    </div>

                    <div className='fe-form-checkboxes'>
                      <Field
                        name='newsletter'
                        message={t('form:checkboxNewsletter')}
                        component={CustomCheckbox}
                      />
                      <Field
                        name='agree'
                        message={t('form:checkboxTnc')}
                        validate={validateChecked}
                        component={CustomCheckbox}
                      />
                    </div>
                    <div className='fe-form-field full'>
                      <Button type='submit' disabled={loading}>
                        {loading
                          ? `${t('form:signingUp')}...`
                          : t('form:signUp')}
                      </Button>
                    </div>
                  </div>
                  <span className='fe-form-error'>
                    {Object.entries(errors).length > 0
                      ? t('error:incompleteForm')
                      : ''}
                  </span>
                  <span className='fe-form-error'>
                    {Object.entries(errors).length < 1 && authError
                      ? t(`error:${getAuthErr(authError.code)}`)
                      : ''}
                  </span>
                </form>
              )}
            </Formik>
          </>
        )}
        <div className='fe-auth-note'>
          {!contest ? (
            <a href='/login'>
              {t('form:alreadyHaveAcc')}? {t('form:login')}
            </a>
          ) : (
            <div onClick={() => this.props.setSignupFlow('login')}>
              {t('form:alreadyHaveAcc')}? {t('form:login')}
            </div>
          )}
        </div>
      </div>
    );
  }
}

SignUp.propTypes = {
  clearAuthError: PropTypes.func.isRequired,
  authError: PropTypes.object,
  doSignUp: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  setSignupFlow: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ authState }) => ({
  user: authState.user,
  authError: authState.authError,
  email: authState.email,
  loading: authState.loading
});

const mapDispatchToProps = {
  doSignUp,
  clearAuthError,
  setSignupFlow
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SignUp)
);
